module.exports = "https://static.wanderu.com/static/media/chiku-blue-english.e2343ca7.png";